<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>文件日历 (提示：你上传的文件将会自动保存在个人云盘中，一个月内可以随时下载)</span>
      </div>
      <div class="fileBox">
        <ul class="clearfix">
          <li v-for="(item,index) in num" :key="index">
            <a href="javascript:void(0);" @click="showFileList(dateStr+item)">
              <div>
                <img src="../../../assets/user/file_icon.jpg" />
                <p>{{dateStr+item}}</p>
              </div>
            </a>
          </li>
        </ul>
      </div>
    </el-card>
    <el-drawer title="文件列表" :visible.sync="drawer" direction="rtl" size="50%">
      <el-table v-loading="loading" :data="fileList" style="width: 100%">
        <el-table-column prop="createtime" label="保存日期" width="180">
          <template slot-scope="scope">{{scope.row.createtime | dateFormat}}</template>
        </el-table-column>
        <el-table-column prop="file" label="文件名"></el-table-column>
        <el-table-column label="操作" width="130">
          <template slot-scope="scope">
            <el-button type="primary" @click="download(scope.row.fileUrl,scope.row.file)">下载</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-drawer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dateStr: '',
      num: '',
      drawer: false,
      token: window.localStorage.getItem('token'),
      page: 1,
      mindate: '',
      maxdate: '',
      fileList: [],
      loading: false
    }
  },
  created() {
    // 获取当月天数
    let date = new Date().toLocaleDateString()
    let year = date.substring(0, 4)
    let month = date.substring(5, 7)
    // let d = new Date(year, month, 0)
    // this.num = d.getDate()
    // this.dateStr = year + '-' + month + '-'
    this.num = new Date().getDate()
    this.dateStr = year + '-' + month + '-'
  },
  methods: {
    showFileList(fileDate) {
      this.loading = true
      this.mindate = fileDate + ' 00:00:00'
      this.maxdate = fileDate + ' 23:59:59'
      this.drawer = true
      this.queryFileList()
    },
    // 查询文件列表
    async queryFileList() {
      this.fileList = []
      let param = new URLSearchParams()
      param.append('token', this.token)
      param.append('page', this.page)
      param.append('mindate', this.mindate)
      param.append('maxdate', this.maxdate)
      const { data: res } = await this.$http.post('api/order/index', param)
      if (res.code) {
        this.loading = false
        let data = res.data.data
        for (let i = 0; i < data.length; i++) {
          let Fileobj = {}
          if (data[i].length === 1) {
            Fileobj.fileUrl = data[i][0].filename
            Fileobj.file = data[i][0].file
            Fileobj.createtime = data[i][0].createtime
            this.fileList.push(Fileobj)
          } else if (data[i].length >= 1) {
            for (let j = 0; j < data[i].length; j++) {
              let Fileobj = {}
              Fileobj.fileUrl = data[i][j].filename
              Fileobj.file = data[i][j].file
              Fileobj.createtime = data[i][j].createtime
              this.fileList.push(Fileobj)
            }
          }
        }
      }
    },
    // 点击下载文件
    download(url, filename) {
      return fetch(url).then(res =>
        res.blob().then(blob => {
          let a = document.createElement('a')
          let url = window.URL.createObjectURL(blob)
          a.href = url
          a.download = filename
          a.click()
          window.URL.revokeObjectURL(url)
        })
      )
    }
  }
}
</script>

<style lang="less" scoped>
.box-card {
  min-height: 600px;
  .fileBox {
    padding: 10px 20px;
    ul {
      li {
        float: left;
        width: 9%;
        text-align: center;
        margin-bottom: 10px;
        div {
          img {
            width: 50%;
            height: 50%;
          }
        }
      }
    }
  }
}
</style>